export const CHANGED = 'routes/CHANGED'
